import { Textarea } from 'components/Form/Input'
import {
  DangerBanner,
  FieldError,
  SectionCard,
  SectionSub,
  SectionTitle,
  SummaryChip,
  SummaryChipLabel,
  SummaryChipValue,
  SummaryRow,
} from '../BulkAssign.styled'

interface Props {
  batchId: string
  employeeCount: number
  targetTeamName: string
  reason: string
  onReasonChange: (r: string) => void
  showErrors?: boolean
}

export const ReasonConfirmStep = ({
  batchId,
  employeeCount,
  targetTeamName,
  reason,
  onReasonChange,
  showErrors,
}: Props) => {
  const reasonError = showErrors && !reason.trim() ? 'Reason is required' : null
  return (
    <>
      <SectionCard>
        <SectionTitle>Operation Summary</SectionTitle>
        <SectionSub>All selected employees will be assigned to this team</SectionSub>
        <SummaryRow>
          <SummaryChip>
            <SummaryChipLabel>BATCH ID</SummaryChipLabel>
            <SummaryChipValue>{batchId}</SummaryChipValue>
          </SummaryChip>
          <SummaryChip>
            <SummaryChipLabel>EMPLOYEES</SummaryChipLabel>
            <SummaryChipValue>{employeeCount}</SummaryChipValue>
          </SummaryChip>
          <SummaryChip>
            <SummaryChipLabel>TARGET</SummaryChipLabel>
            <SummaryChipValue>{targetTeamName || '—'}</SummaryChipValue>
          </SummaryChip>
        </SummaryRow>
      </SectionCard>

      <SectionCard>
        <SectionTitle>Reason for Bulk Operation</SectionTitle>
        <SectionSub>This reason will be recorded in the audit log for all assignment records.</SectionSub>
        <Textarea
          label='Reason for Bulk *'
          placeholder='e.g. Onboarding batch – 25 new assigned to Alpha crew'
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          rows={3}
        />
        {reasonError && <FieldError>{reasonError}</FieldError>}
      </SectionCard>

      <DangerBanner>
        <span>⚠</span>
        <div>
          <strong>Irreversible Action</strong>
          This will create individual assignment records under this BATCH ID. Each assignment is
          atomic and auditable separately. This action cannot be undone — employees must be
          individually reassigned to reverse.
        </div>
      </DangerBanner>
    </>
  )
}
